import React from 'react';

import Image from '3-components/Image/Image';
import Icon from '3-components/Icon/Icon';
import { FormatDistanceNumber } from '3-components/Utils/NumberUtils';
import RenderDistance from './LocationUtils';

/* eslint-disable camelcase */
interface LocationFSTHitProps {
    objectID: string,
    name: string,
    type: string,
    // intro: string,
    phone: string,
    street: string,
    suburb: string,
    state: string,
    postcode: string,
    '_geoloc': {
        'lat': -27.5636094230873,
        'lng': 152.273006402072
    },
    image: string,
    email?: string,
    '_rankingInfo'?: {
        geoDistance?: number
    }
}

interface LocationCardFSTProps {
    hit: LocationFSTHitProps
}

const LocationCardFST = (props: LocationCardFSTProps) => {
    const { hit } = props;
    // eslint-disable-next-line no-underscore-dangle
    const distance = hit._rankingInfo?.geoDistance;
    const formattedDistance = FormatDistanceNumber(distance ? distance / 1000 : undefined);

    return (
        <div className="location-card location-card-fst">
            <Image
                imgSrc={hit.image ? hit.image : '/assets/images/ArticleCardDefault.jpg'}
                imgAlt={`image of ${hit.name}`}
                imgCustomClass="location-card-image-container"
            />
            <div className="location-content location-content-fst">
                {formattedDistance && RenderDistance(distance, formattedDistance)}
                <h3 className="location-content-title">{hit.name}</h3>
                <ul className="location-info">
                    <li className="location-info-item">
                        <Icon icon="map-pin" />
                        <span>{`${hit.street}, ${hit.suburb} ${hit.state} ${hit.postcode}`}</span>
                    </li>
                    {hit.email && (
                        <li className="location-info-item">
                            <Icon icon="mail" />
                            <a href={`mailto:${hit.email}`}>{hit.email}</a>
                        </li>
                    )}
                    {hit.phone && (
                        <li className="location-info-item">
                            <Icon icon="phone" />
                            <a href={`tel:${hit.phone}`}>{hit.phone}</a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};
/* eslint-disable camelcase */
export default LocationCardFST;
